import { Dispatch, SetStateAction, createContext } from 'react'

import { AnalyticsQueryColumn, AnalyticsQueryFilter } from '@hap/analytics'
import { VOID_FUNC } from '@hap/constants'

import { SavedQueryFilter } from '../saved-query'

export const FilterContext = createContext<{
  filter?: AnalyticsQueryFilter
  setField: (field: AnalyticsQueryFilter['field'] | null) => void
  field: AnalyticsQueryFilter['field'] | null
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onSelect: (updates: SavedQueryFilter) => void
  selectableFilters?: AnalyticsQueryColumn[]
  contextFilters?: {
    [key: string]: {
      $eq: string[]
    }
  }
}>({
  filter: undefined,
  setField: VOID_FUNC,
  field: null,
  open: false,
  setOpen: VOID_FUNC,
  onSelect: VOID_FUNC,
  selectableFilters: undefined,
})
